(function () {
  function initMobileBottomNav() {
    const nav = document.querySelector("[data-mobile-bottom-nav]");
    if (!nav || nav.dataset.mobileBottomNavBound === "true") return;
    nav.dataset.mobileBottomNavBound = "true";

    document.body.classList.add("mobile-bottom-nav-enabled");

    const menuButton = nav.querySelector("[data-mobile-nav-menu]");
    const cartButton = nav.querySelector("[data-mobile-nav-cart]");
    const cartIcon = cartButton
      ? cartButton.querySelector(".mobile-bottom-nav__icon")
      : null;
    const filterButton = nav.querySelector("[data-mobile-nav-filter]");
    const sortButton = document.querySelector("[data-mobile-nav-sort]");
    const searchButton = document.querySelector("[data-mobile-nav-search]");
    const quickButton = document.querySelector("[data-mobile-nav-quick]");
    const filterIcon = filterButton
      ? filterButton.querySelector(".mobile-bottom-nav__icon")
      : null;
    const brandTriggers = Array.from(
      document.querySelectorAll("[data-mobile-nav-brands]")
    );

    const brandSheet = document.querySelector("[data-mobile-brand-sheet]");
    const brandSheetPanel = brandSheet
      ? brandSheet.querySelector(".mobile-brand-sheet__panel")
      : null;
    const brandSheetHeader = brandSheetPanel
      ? brandSheetPanel.querySelector(".mobile-brand-sheet__header")
      : null;
    const brandSheetCloseButtons = brandSheet
      ? brandSheet.querySelectorAll("[data-mobile-brand-sheet-close]")
      : [];
    const brandSheetLinks = brandSheet
      ? brandSheet.querySelectorAll("[data-mobile-brand-sheet-link]")
      : [];
    const desktopBrandLinks = Array.from(
      document.querySelectorAll(".header__brand .header__brand-label")
    );
    const sortSheet = document.querySelector("[data-mobile-sort-sheet]");
    const sortSheetPanel = sortSheet
      ? sortSheet.querySelector(".mobile-sort-sheet__panel")
      : null;
    const sortSheetHeader = sortSheetPanel
      ? sortSheetPanel.querySelector(".mobile-sort-sheet__header")
      : null;
    const sortSheetCloseButtons = sortSheet
      ? sortSheet.querySelectorAll("[data-mobile-sort-sheet-close]")
      : [];
    const sortSheetOptions = sortSheet
      ? sortSheet.querySelectorAll("[data-mobile-sort-sheet-option]")
      : [];

    const quickTray = document.querySelector("[data-mobile-quick-tray]");
    const quickTrayPanel = quickTray
      ? quickTray.querySelector(".mobile-quick-tray__panel")
      : null;
    const quickTrayTitle = quickTrayPanel
      ? quickTrayPanel.querySelector(".mobile-quick-tray__title")
      : null;
    const quickTrayCloseButtons = quickTray
      ? quickTray.querySelectorAll("[data-mobile-quick-tray-close]")
      : [];
    const quickTrayLinks = quickTray
      ? quickTray.querySelectorAll("[data-mobile-quick-tray-link]")
      : [];

    const menuSheet = document.querySelector("[data-mobile-menu-sheet]");
    const menuSheetPanel = menuSheet
      ? menuSheet.querySelector(".mobile-menu-sheet__panel")
      : null;
    const menuSheetHeader = menuSheetPanel
      ? menuSheetPanel.querySelector(".mobile-menu-sheet__header")
      : null;
    const menuSheetCloseButtons = menuSheet
      ? menuSheet.querySelectorAll("[data-mobile-menu-sheet-close]")
      : [];
    const menuSheetLinks = menuSheet
      ? menuSheet.querySelectorAll("[data-mobile-menu-sheet-link]")
      : [];
    const menuFilterInput = menuSheet
      ? menuSheet.querySelector("[data-mobile-menu-filter]")
      : null;
    const menuFilterNodes = menuSheet
      ? Array.from(menuSheet.querySelectorAll("[data-mobile-menu-node]"))
      : [];
    const menuTopNodes = menuSheet
      ? Array.from(menuSheet.querySelectorAll(".mobile-menu-sheet__list > .mobile-menu-sheet__node"))
      : [];
    const menuEmptyState = menuSheet
      ? menuSheet.querySelector("[data-mobile-menu-empty]")
      : null;
    const menuAccordionDetails = menuSheet
      ? Array.from(menuSheet.querySelectorAll(".mobile-menu-sheet__details"))
      : [];
    const menuNodeChildren = new Map();
    const menuNodeDetails = new Map();

    const sidecart = document.getElementById("side-cart");
    const menuDrawerDetails = document.querySelector(
      "header-drawer details.menu-drawer-container"
    );
    const menuSummary = document.querySelector(
      "header-drawer details.menu-drawer-container > summary.header__icon--menu"
    );

    const searchModalDetails =
      document.querySelector("details-modal.header__search.header--v2-hide > details") ||
      document.querySelector("details-modal.header__search > details");
    const searchSummary = searchModalDetails
      ? searchModalDetails.querySelector("summary.header__icon--search")
      : null;
    const searchSheet = document.querySelector("[data-mobile-search-sheet]");
    const searchSheetPanel = searchSheet
      ? searchSheet.querySelector(".mobile-search-sheet__panel")
      : null;
    const searchSheetHeader = searchSheetPanel
      ? searchSheetPanel.querySelector(".mobile-search-sheet__header")
      : null;
    const searchSheetInput = searchSheet
      ? searchSheet.querySelector("#Search-In-Mobile-Sheet")
      : null;
    const searchSheetCloseButtons = searchSheet
      ? searchSheet.querySelectorAll("[data-mobile-search-sheet-close]")
      : [];
    const searchSheetShortcutLinks = searchSheet
      ? searchSheet.querySelectorAll("[data-mobile-search-sheet-link]")
      : [];

    let hideBrandSheetTimer;
    let hideSortSheetTimer;
    let hideQuickTrayTimer;
    let hideSearchSheetTimer;
    let hideMenuSheetTimer;
    let filterMenuFrame = 0;
    let viewportInsetsFrame = 0;
    let pendingScrollRevealTimer = 0;
    let queuedMenuFilterValue = "";
    let isFilteringMenu = false;
    let activeCartCountBubble = null;
    let cartCountBubbleObserver;
    let cartCountBubbleRootObserver;
    let pendingCartCountRefreshTimer = 0;
    let isCartCountRefreshInFlight = false;
    let lastFocusedElement;
    let isScrollHidden = false;
    let activeSheetSwipe = null;
    let isSheetScrollLocked = false;
    let sheetScrollLockY = 0;
    let sheetScrollLockStyles = null;
    let lastScrollY = Math.max(window.scrollY || 0, 0);
    let scrollTicking = false;
    let upDistance = 0;
    let downDistance = 0;
    let lastViewportInset = 0;
    let lastViewportInsetChangeAt = Date.now();
    const viewportRevealSettleMs = 160;
    const cartCountRefreshDelayMs = 90;
    const sheetSwipeCloseThresholdPx = 96;
    const sheetSwipeCloseVelocityThreshold = 0.45;
    const mobileSheetSwipeQuery = window.matchMedia("(max-width: 749px)");
    const mobileSheetLockQuery = window.matchMedia("(max-width: 749px)");
    const brandThemeColors = {
      all: "#060606",
      hugo: "#b51f29",
      boss: "#987147",
      contemporary: "#0964a2",
    };

    function getThemeColorMetaTags() {
      const tags = Array.from(document.querySelectorAll('meta[name="theme-color"]'));
      if (tags.length) return tags;

      const fallback = document.createElement("meta");
      fallback.setAttribute("name", "theme-color");
      document.head.appendChild(fallback);
      return [fallback];
    }

    function getBrandThemeFromPathname(pathname) {
      const path = String(pathname || "").toLowerCase();
      if (path.indexOf("/pages/hugo") !== -1) return "hugo";
      if (path.indexOf("/pages/boss") !== -1) return "boss";
      if (path.indexOf("/pages/contemporary") !== -1) return "contemporary";
      return "all";
    }

    function getBrandThemeFromLink(link) {
      if (!link) return null;
      if (link.classList.contains("mobile-brand-sheet__link--hugo")) return "hugo";
      if (link.classList.contains("mobile-brand-sheet__link--boss")) return "boss";
      if (link.classList.contains("mobile-brand-sheet__link--contemporary")) return "contemporary";
      if (link.classList.contains("mobile-brand-sheet__link--all")) return "all";
      if (link.classList.contains("header__brand-label--hugo")) return "hugo";
      if (link.classList.contains("header__brand-label--boss")) return "boss";
      if (link.classList.contains("header__brand-label--contemporary")) return "contemporary";
      if (link.classList.contains("header__brand-label--allbrands")) return "all";

      const href = link.getAttribute("href");
      if (!href) return null;
      try {
        const parsedUrl = new URL(href, window.location.origin);
        return getBrandThemeFromPathname(parsedUrl.pathname);
      } catch (error) {
        return null;
      }
    }

    function getBrandThemeFromChipClass() {
      const chip = document.querySelector(".mobile-bottom-nav__brand-chip");
      if (!chip) return null;
      if (chip.classList.contains("mobile-bottom-nav__brand-chip--hugo")) return "hugo";
      if (chip.classList.contains("mobile-bottom-nav__brand-chip--boss")) return "boss";
      if (chip.classList.contains("mobile-bottom-nav__brand-chip--contemporary")) return "contemporary";
      if (chip.classList.contains("mobile-bottom-nav__brand-chip--all")) return "all";
      return null;
    }

    function setThemeColorForBrand(brandKey) {
      const metaTags = getThemeColorMetaTags();
      const resolvedBrand = brandThemeColors[brandKey] ? brandKey : "all";
      const color = brandThemeColors[resolvedBrand];
      metaTags.forEach(function (metaTag) {
        metaTag.setAttribute("content", color);
      });
    }

    function syncThemeColorFromState() {
      const activeMobileBrandLink = document.querySelector(
        ".mobile-brand-sheet__link.mobile-brand-sheet__link--active"
      );
      const activeDesktopBrandLink = document.querySelector(
        ".header__brand .header__brand-label.header__brand-label--active"
      );

      const brandFromState =
        getBrandThemeFromLink(activeMobileBrandLink) ||
        getBrandThemeFromLink(activeDesktopBrandLink) ||
        getBrandThemeFromChipClass() ||
        getBrandThemeFromPathname(window.location.pathname);

      setThemeColorForBrand(brandFromState);
    }

    function installThemeColorHistorySync() {
      if (window.__mobileBrandThemeColorHistorySyncInstalled) return;
      window.__mobileBrandThemeColorHistorySyncInstalled = true;

      const originalPushState = window.history.pushState;
      const originalReplaceState = window.history.replaceState;

      window.history.pushState = function () {
        const result = originalPushState.apply(this, arguments);
        window.dispatchEvent(new Event("mobile-brand-theme-history-change"));
        return result;
      };

      window.history.replaceState = function () {
        const result = originalReplaceState.apply(this, arguments);
        window.dispatchEvent(new Event("mobile-brand-theme-history-change"));
        return result;
      };
    }

    function isBrandSheetOpen() {
      return Boolean(brandSheet && !brandSheet.hidden);
    }

    function isSortSheetOpen() {
      return Boolean(sortSheet && !sortSheet.hidden);
    }

    function isQuickTrayOpen() {
      return Boolean(quickTray && !quickTray.hidden);
    }

    function isSearchSheetOpen() {
      return Boolean(searchSheet && !searchSheet.hidden);
    }

    function isMenuSheetOpen() {
      return Boolean(menuSheet && menuSheet.classList.contains("is-open"));
    }

    function isDrawerOpen() {
      return Boolean(menuDrawerDetails && menuDrawerDetails.hasAttribute("open"));
    }

    function isSearchOpen() {
      return Boolean(searchModalDetails && searchModalDetails.hasAttribute("open"));
    }

    function isSidecartVisible() {
      return Boolean(sidecart && sidecart.classList.contains("visible"));
    }

    function getCollectionFilterContainer() {
      return document.querySelector(".facets-container--v2");
    }

    function getCollectionFilterTrigger() {
      return document.getElementById("collection-filtter--btn");
    }

    function getCollectionFilterDrawerClose() {
      return document.getElementById("facets_drawer_close");
    }

    function getCollectionFilterDrawerElement() {
      return document.querySelector("facets-drawer-v2");
    }

    function isCollectionFilterDrawerOpen() {
      const collectionFilterContainer = getCollectionFilterContainer();
      return Boolean(
        collectionFilterContainer &&
          collectionFilterContainer.classList.contains("open")
      );
    }

    function isAnyMobileSheetClassActive() {
      return (
        document.body.classList.contains("mobile-menu-sheet-open") ||
        document.body.classList.contains("mobile-bottom-search-open") ||
        document.body.classList.contains("mobile-quick-tray-open") ||
        document.body.classList.contains("mobile-brand-sheet-open") ||
        document.body.classList.contains("mobile-sort-sheet-open")
      );
    }

    function lockSheetScroll() {
      if (isSheetScrollLocked) return;
      if (!mobileSheetLockQuery.matches) return;

      const bodyStyle = document.body.style;
      sheetScrollLockStyles = {
        position: bodyStyle.position || "",
        top: bodyStyle.top || "",
        left: bodyStyle.left || "",
        right: bodyStyle.right || "",
        width: bodyStyle.width || "",
        paddingRight: bodyStyle.paddingRight || "",
      };

      sheetScrollLockY = Math.max(window.scrollY || window.pageYOffset || 0, 0);
      const scrollbarGap = Math.max(
        0,
        window.innerWidth - document.documentElement.clientWidth
      );

      bodyStyle.position = "fixed";
      bodyStyle.top = "-" + sheetScrollLockY + "px";
      bodyStyle.left = "0";
      bodyStyle.right = "0";
      bodyStyle.width = "100%";
      if (scrollbarGap > 0) {
        bodyStyle.paddingRight = scrollbarGap + "px";
      }

      isSheetScrollLocked = true;
      document.body.setAttribute("data-mobile-sheet-scroll-lock", "true");
    }

    function unlockSheetScroll(force) {
      if (!isSheetScrollLocked) return;
      if (!force && mobileSheetLockQuery.matches && isAnyMobileSheetClassActive()) {
        return;
      }

      const bodyStyle = document.body.style;
      const styles = sheetScrollLockStyles || {};
      bodyStyle.position = styles.position || "";
      bodyStyle.top = styles.top || "";
      bodyStyle.left = styles.left || "";
      bodyStyle.right = styles.right || "";
      bodyStyle.width = styles.width || "";
      bodyStyle.paddingRight = styles.paddingRight || "";

      isSheetScrollLocked = false;
      sheetScrollLockStyles = null;
      document.body.removeAttribute("data-mobile-sheet-scroll-lock");

      window.requestAnimationFrame(function () {
        window.scrollTo(0, sheetScrollLockY);
      });
    }

    function syncSheetScrollLock(forceUnlock) {
      if (forceUnlock || !mobileSheetLockQuery.matches) {
        unlockSheetScroll(true);
        return;
      }

      if (isAnyMobileSheetClassActive()) {
        lockSheetScroll();
      } else {
        unlockSheetScroll(false);
      }
    }

    function setBrandTriggerExpanded(isExpanded) {
      brandTriggers.forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", isExpanded ? "true" : "false");
      });
    }

    function setSortTriggerExpanded(isExpanded) {
      if (!sortButton) return;
      sortButton.setAttribute("aria-expanded", isExpanded ? "true" : "false");
    }

    function getFocusableElements(container) {
      if (!container) return [];
      const selectors =
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
      return Array.from(container.querySelectorAll(selectors)).filter(function (el) {
        return el.offsetParent !== null;
      });
    }

    function setScrollVisibility(shouldHide) {
      if (isScrollHidden === shouldHide) return;
      isScrollHidden = shouldHide;
      document.body.classList.toggle("mobile-bottom-nav-hidden-scroll", shouldHide);
    }

    function parseCartCount(value) {
      if (value == null) return null;
      const normalized = String(value).replace(/[^\d]/g, "");
      if (!normalized) return 0;
      const parsed = Number.parseInt(normalized, 10);
      return Number.isFinite(parsed) ? parsed : null;
    }

    function getActiveFilterCountFromUrl() {
      const params = new URLSearchParams(window.location.search || "");
      let total = 0;
      let hasPriceRange = false;

      params.forEach(function (value, key) {
        if (!key || !value) return;
        if (!key.startsWith("filter.")) return;
        if (key.indexOf(".price.gte") !== -1 || key.indexOf(".price.lte") !== -1) {
          hasPriceRange = true;
          return;
        }
        total += 1;
      });

      if (hasPriceRange) total += 1;
      return total;
    }

    function formatCartCount(count) {
      if (!Number.isFinite(count) || count <= 0) return "";
      return count < 100 ? String(count) : "99+";
    }

    function getHeaderCartCountBubble() {
      return (
        document.querySelector("#cart-icon-bubble .cart-count-bubble") ||
        document.querySelector(".cart-count-bubble")
      );
    }

    function getCartCountFromBubble(bubble) {
      if (!bubble) return null;
      if (bubble.classList.contains("hidden")) return 0;

      const visibleCountNode =
        bubble.querySelector("span[aria-hidden='true']") ||
        bubble.querySelector("span:not(.visually-hidden)");
      const source = visibleCountNode ? visibleCountNode.textContent : bubble.textContent;
      return parseCartCount(source);
    }

    function setMobileCartBadgeCount(count) {
      if (!cartIcon) return;

      const normalizedCount = Number.isFinite(count) ? count : 0;
      const existingBadge = cartIcon.querySelector(".mobile-bottom-nav__badge");

      if (normalizedCount <= 0) {
        if (existingBadge) existingBadge.remove();
        return;
      }

      const displayValue = formatCartCount(normalizedCount);
      if (!displayValue) {
        if (existingBadge) existingBadge.remove();
        return;
      }

      const badge = existingBadge || document.createElement("span");
      if (!existingBadge) {
        badge.className = "mobile-bottom-nav__badge";
        badge.setAttribute("aria-hidden", "true");
        cartIcon.appendChild(badge);
      }
      badge.textContent = displayValue;
    }

    function setMobileFilterBadgeCount(count) {
      if (!filterIcon) return;

      const normalizedCount = Number.isFinite(count) ? count : 0;
      const existingBadge = filterIcon.querySelector(".mobile-bottom-nav__badge");
      if (normalizedCount <= 0) {
        if (existingBadge) existingBadge.remove();
        return;
      }

      const displayValue = formatCartCount(normalizedCount);
      if (!displayValue) {
        if (existingBadge) existingBadge.remove();
        return;
      }

      const badge = existingBadge || document.createElement("span");
      if (!existingBadge) {
        badge.className = "mobile-bottom-nav__badge";
        badge.setAttribute("aria-hidden", "true");
        filterIcon.appendChild(badge);
      }
      badge.textContent = displayValue;
    }

    function syncMobileFilterBadgeFromUrl() {
      setMobileFilterBadgeCount(getActiveFilterCountFromUrl());
    }

    function syncMobileCartBadgeFromBubble() {
      const bubble = activeCartCountBubble || getHeaderCartCountBubble();
      const count = getCartCountFromBubble(bubble);
      if (count == null) return false;
      setMobileCartBadgeCount(count);
      return true;
    }

    function getCartJsonUrl() {
      const root =
        window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";
      return root + "cart.js";
    }

    function refreshCartCountFromApi() {
      if (isCartCountRefreshInFlight) return;
      isCartCountRefreshInFlight = true;

      window
        .fetch(getCartJsonUrl(), { credentials: "same-origin" })
        .then(function (response) {
          if (!response || !response.ok) return null;
          return response.json();
        })
        .then(function (payload) {
          if (payload && Number.isFinite(payload.item_count)) {
            setMobileCartBadgeCount(payload.item_count);
            return;
          }
          syncMobileCartBadgeFromBubble();
        })
        .catch(function () {
          syncMobileCartBadgeFromBubble();
        })
        .finally(function () {
          isCartCountRefreshInFlight = false;
        });
    }

    function scheduleCartCountRefresh(delay) {
      if (pendingCartCountRefreshTimer) {
        window.clearTimeout(pendingCartCountRefreshTimer);
      }
      pendingCartCountRefreshTimer = window.setTimeout(function () {
        pendingCartCountRefreshTimer = 0;
        refreshCartCountFromApi();
      }, typeof delay === "number" ? delay : cartCountRefreshDelayMs);
    }

    function observeHeaderCartBubble() {
      const nextBubble = getHeaderCartCountBubble();
      if (nextBubble === activeCartCountBubble) return;

      if (cartCountBubbleObserver) {
        cartCountBubbleObserver.disconnect();
      }

      activeCartCountBubble = nextBubble;
      if (!activeCartCountBubble) {
        setMobileCartBadgeCount(0);
        return;
      }

      cartCountBubbleObserver = new MutationObserver(function () {
        if (!syncMobileCartBadgeFromBubble()) {
          scheduleCartCountRefresh(0);
        }
      });

      cartCountBubbleObserver.observe(activeCartCountBubble, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["class"],
      });

      syncMobileCartBadgeFromBubble();
    }

    function observeHeaderCartBubbleReplacements() {
      const root = document.getElementById("cart-icon-bubble") || document.body;
      if (!root) return;
      if (cartCountBubbleRootObserver) {
        cartCountBubbleRootObserver.disconnect();
      }

      cartCountBubbleRootObserver = new MutationObserver(function () {
        observeHeaderCartBubble();
      });

      cartCountBubbleRootObserver.observe(root, {
        childList: true,
        subtree: true,
      });
    }

    function getRequestPathname(input) {
      try {
        if (typeof input === "string") {
          return new URL(input, window.location.origin).pathname;
        }
        if (input && typeof input.url === "string") {
          return new URL(input.url, window.location.origin).pathname;
        }
      } catch (error) {
        return "";
      }
      return "";
    }

    function isCartMutationPath(pathname) {
      return /\/cart\/(add|change|update|clear)(\.js)?$/.test(pathname || "");
    }

    function installCartFetchObserver() {
      if (typeof window.fetch !== "function") return;
      if (window.__mobileBottomNavCartFetchObserved) return;

      const nativeFetch = window.fetch.bind(window);
      window.__mobileBottomNavCartFetchObserved = true;
      window.fetch = function (input, init) {
        const pathname = getRequestPathname(input);
        const request = nativeFetch(input, init);

        if (isCartMutationPath(pathname)) {
          request.finally(function () {
            scheduleCartCountRefresh();
          });
        }

        return request;
      };
    }

    function clearPendingScrollReveal() {
      if (!pendingScrollRevealTimer) return;
      window.clearTimeout(pendingScrollRevealTimer);
      pendingScrollRevealTimer = 0;
    }

    function scheduleScrollRevealAfterViewportSettles() {
      clearPendingScrollReveal();

      const elapsed = Date.now() - lastViewportInsetChangeAt;
      const waitMs = elapsed >= viewportRevealSettleMs
        ? 0
        : viewportRevealSettleMs - elapsed;

      if (!waitMs) {
        setScrollVisibility(false);
        return;
      }

      pendingScrollRevealTimer = window.setTimeout(function () {
        pendingScrollRevealTimer = 0;

        if (shouldLockNavVisible()) {
          setScrollVisibility(false);
          return;
        }

        const sinceLastInsetChange = Date.now() - lastViewportInsetChangeAt;
        if (sinceLastInsetChange < viewportRevealSettleMs) {
          scheduleScrollRevealAfterViewportSettles();
          return;
        }

        setScrollVisibility(false);
      }, waitMs);
    }

    function getViewportBottomInset() {
      if (!window.visualViewport) return 0;
      const viewport = window.visualViewport;
      const inset = window.innerHeight - (viewport.height + viewport.offsetTop);
      return inset > 0 ? Math.round(inset) : 0;
    }

    function syncViewportInsets() {
      viewportInsetsFrame = 0;

      const viewportInset = getViewportBottomInset();
      if (viewportInset !== lastViewportInset) {
        lastViewportInset = viewportInset;
        lastViewportInsetChangeAt = Date.now();
      }
      document.documentElement.style.setProperty(
        "--mobile-viewport-bottom-inset",
        viewportInset + "px"
      );

      const menuOpen = isMenuSheetOpen();
      const searchOpen = isSearchSheetOpen();
      const overlayInset = menuOpen || searchOpen ? viewportInset : 0;
      document.documentElement.style.setProperty(
        "--mobile-overlay-keyboard-inset",
        overlayInset + "px"
      );
    }

    function scheduleViewportInsetsSync() {
      if (viewportInsetsFrame) return;
      viewportInsetsFrame = window.requestAnimationFrame(syncViewportInsets);
    }

    function resetScrollAccumulation() {
      upDistance = 0;
      downDistance = 0;
    }

    function clearSheetInlineStyles(panel) {
      if (!panel) return;
      panel.style.transform = "";
      panel.style.transition = "";
      panel.style.opacity = "";
    }

    function resetActiveSheetSwipe(panel) {
      if (!activeSheetSwipe) return;
      if (!panel || activeSheetSwipe.panel === panel) {
        activeSheetSwipe = null;
      }
    }

    function getTouchByIdentifier(touchList, identifier) {
      if (identifier == null || !touchList) return null;
      for (let i = 0; i < touchList.length; i += 1) {
        if (touchList[i].identifier === identifier) return touchList[i];
      }
      return null;
    }

    function canStartSheetSwipe(sheet, event, touch) {
      if (!mobileSheetSwipeQuery.matches) return false;
      if (!sheet || !sheet.panel || typeof sheet.isOpen !== "function") return false;
      if (!sheet.isOpen()) return false;
      if (!event.touches || event.touches.length !== 1) return false;

      const target = event.target;
      if (sheet.handle) {
        return sheet.handle.contains(target);
      }

      if (!sheet.panel.contains(target)) return false;
      const rect = sheet.panel.getBoundingClientRect();
      return touch.clientY <= rect.top + 72;
    }

    function beginSheetSwipe(sheet, event) {
      if (!sheet || !sheet.panel) return;
      const touch = event.touches && event.touches[0];
      if (!touch) return;
      if (!canStartSheetSwipe(sheet, event, touch)) return;

      activeSheetSwipe = {
        identifier: touch.identifier,
        startY: touch.clientY,
        currentY: touch.clientY,
        startedAt: Date.now(),
        panel: sheet.panel,
        close: sheet.close,
      };

      sheet.panel.style.transition = "none";
    }

    function handleSheetSwipeMove(event) {
      if (!activeSheetSwipe) return;
      const touch = getTouchByIdentifier(event.touches, activeSheetSwipe.identifier);
      if (!touch) return;

      activeSheetSwipe.currentY = touch.clientY;
      const deltaY = Math.max(0, activeSheetSwipe.currentY - activeSheetSwipe.startY);
      if (deltaY <= 0) return;

      activeSheetSwipe.panel.style.transform = "translateY(" + deltaY + "px)";
      activeSheetSwipe.panel.style.opacity = String(
        Math.max(0.68, 1 - Math.min(deltaY / 300, 0.32))
      );
      event.preventDefault();
    }

    function handleSheetSwipeEnd(event) {
      if (!activeSheetSwipe) return;

      const touch =
        getTouchByIdentifier(event.changedTouches, activeSheetSwipe.identifier) ||
        getTouchByIdentifier(event.touches, activeSheetSwipe.identifier);

      const endY = touch ? touch.clientY : activeSheetSwipe.currentY;
      const distance = Math.max(0, endY - activeSheetSwipe.startY);
      const elapsed = Math.max(1, Date.now() - activeSheetSwipe.startedAt);
      const velocity = distance / elapsed;
      const shouldClose =
        distance >= sheetSwipeCloseThresholdPx ||
        velocity >= sheetSwipeCloseVelocityThreshold;

      const swipe = activeSheetSwipe;
      activeSheetSwipe = null;

      if (shouldClose) {
        clearSheetInlineStyles(swipe.panel);
        if (typeof swipe.close === "function") swipe.close();
        return;
      }

      swipe.panel.style.transition =
        "transform 220ms cubic-bezier(0.22, 1, 0.36, 1), opacity 220ms ease";
      swipe.panel.style.transform = "";
      swipe.panel.style.opacity = "";
      window.setTimeout(function () {
        clearSheetInlineStyles(swipe.panel);
      }, 240);
    }

    function closeBrandSheet(returnFocus) {
      if (!brandSheet || !isBrandSheetOpen()) return;
      clearSheetInlineStyles(brandSheetPanel);
      resetActiveSheetSwipe(brandSheetPanel);
      brandSheet.classList.remove("is-open");
      brandSheet.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mobile-brand-sheet-open");
      syncSheetScrollLock();
      setBrandTriggerExpanded(false);

      window.clearTimeout(hideBrandSheetTimer);
      hideBrandSheetTimer = window.setTimeout(function () {
        brandSheet.hidden = true;
        syncSheetScrollLock();
      }, 210);

      if (
        returnFocus &&
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function" &&
        document.body.contains(lastFocusedElement)
      ) {
        lastFocusedElement.focus();
      }
    }

    function openBrandSheet(trigger) {
      if (!brandSheet || isBrandSheetOpen()) return;
      closeQuickTray(false);
      closeSortSheet(false);
      closeSearchSheet(false);
      closeMenuSheet(false);
      setScrollVisibility(false);
      clearSheetInlineStyles(brandSheetPanel);
      lastFocusedElement = trigger || document.activeElement;

      window.clearTimeout(hideBrandSheetTimer);
      brandSheet.hidden = false;
      brandSheet.setAttribute("aria-hidden", "false");
      document.body.classList.add("mobile-brand-sheet-open");
      syncSheetScrollLock();
      setBrandTriggerExpanded(true);

      window.requestAnimationFrame(function () {
        brandSheet.classList.add("is-open");
      });

      const focusables = getFocusableElements(brandSheet);
      if (focusables[0]) {
        focusables[0].focus();
      } else if (brandSheetPanel) {
        brandSheetPanel.focus();
      }
    }

    function closeQuickTray(returnFocus) {
      if (!quickTray || !isQuickTrayOpen()) return;
      clearSheetInlineStyles(quickTrayPanel);
      resetActiveSheetSwipe(quickTrayPanel);
      quickTray.classList.remove("is-open");
      quickTray.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mobile-quick-tray-open");
      syncSheetScrollLock();

      window.clearTimeout(hideQuickTrayTimer);
      hideQuickTrayTimer = window.setTimeout(function () {
        quickTray.hidden = true;
        syncSheetScrollLock();
      }, 200);

      if (
        returnFocus &&
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function" &&
        document.body.contains(lastFocusedElement)
      ) {
        lastFocusedElement.focus();
      }
    }

    function closeSearchSheet(returnFocus) {
      if (!searchSheet || !isSearchSheetOpen()) return;
      clearSheetInlineStyles(searchSheetPanel);
      resetActiveSheetSwipe(searchSheetPanel);
      searchSheet.classList.remove("is-open");
      searchSheet.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mobile-bottom-search-open");
      syncSheetScrollLock();
      scheduleViewportInsetsSync();

      window.clearTimeout(hideSearchSheetTimer);
      hideSearchSheetTimer = window.setTimeout(function () {
        searchSheet.hidden = true;
        syncSheetScrollLock();
      }, 200);

      if (
        returnFocus &&
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function" &&
        document.body.contains(lastFocusedElement)
      ) {
        lastFocusedElement.focus();
      }
    }

    function openSearchSheet(trigger) {
      if (!searchSheet || isSearchSheetOpen()) return;
      closeBrandSheet(false);
      closeSortSheet(false);
      closeQuickTray(false);
      closeMenuSheet(false);
      setScrollVisibility(false);
      clearSheetInlineStyles(searchSheetPanel);
      if (isSearchOpen() && searchSummary) {
        searchSummary.click();
      }
      lastFocusedElement = trigger || document.activeElement;

      window.clearTimeout(hideSearchSheetTimer);
      searchSheet.hidden = false;
      searchSheet.setAttribute("aria-hidden", "false");
      document.body.classList.add("mobile-bottom-search-open");
      syncSheetScrollLock();
      scheduleViewportInsetsSync();

      window.requestAnimationFrame(function () {
        searchSheet.classList.add("is-open");
      });

      if (searchSheetInput) {
        window.setTimeout(function () {
          searchSheetInput.focus();
        }, 120);
      } else if (searchSheetPanel) {
        searchSheetPanel.focus();
      }
    }

    function openQuickTray(trigger) {
      if (!quickTray || isQuickTrayOpen()) return;
      closeBrandSheet(false);
      closeSortSheet(false);
      closeSearchSheet(false);
      closeMenuSheet(false);
      setScrollVisibility(false);
      clearSheetInlineStyles(quickTrayPanel);
      lastFocusedElement = trigger || document.activeElement;

      window.clearTimeout(hideQuickTrayTimer);
      quickTray.hidden = false;
      quickTray.setAttribute("aria-hidden", "false");
      document.body.classList.add("mobile-quick-tray-open");
      syncSheetScrollLock();

      window.requestAnimationFrame(function () {
        quickTray.classList.add("is-open");
      });

      const focusables = getFocusableElements(quickTray);
      if (focusables[0]) {
        focusables[0].focus();
      } else if (quickTrayPanel) {
        quickTrayPanel.focus();
      }
    }

    function resetMenuFilter() {
      if (!menuSheet) return;

      if (filterMenuFrame) {
        window.cancelAnimationFrame(filterMenuFrame);
        filterMenuFrame = 0;
      }
      queuedMenuFilterValue = "";
      isFilteringMenu = false;

      if (menuFilterInput) {
        menuFilterInput.value = "";
      }

      menuFilterNodes.forEach(function (node) {
        node.hidden = false;
        node.dataset.mobileMenuMatch = "1";
      });

      menuAccordionDetails.forEach(function (details) {
        details.open = false;
      });

      if (menuEmptyState) {
        menuEmptyState.hidden = true;
      }
    }

    function filterMenuItems(rawQuery) {
      if (!menuSheet) return;

      const query = (rawQuery || "").trim().toLowerCase();
      if (!query) {
        resetMenuFilter();
        return;
      }

      isFilteringMenu = true;
      try {
        menuFilterNodes.forEach(function (node) {
          const text = (node.getAttribute("data-mobile-menu-text") || "").toLowerCase();
          const selfMatch = text.includes(query);
          node.dataset.mobileMenuSelfMatch = selfMatch ? "1" : "0";
        });

        for (let i = menuFilterNodes.length - 1; i >= 0; i -= 1) {
          const node = menuFilterNodes[i];
          const selfMatch = node.dataset.mobileMenuSelfMatch === "1";
          const descendantMatch = (menuNodeChildren.get(node) || []).some(function (child) {
            return child.dataset.mobileMenuMatch === "1";
          });
          const match = selfMatch || descendantMatch;
          node.dataset.mobileMenuMatch = match ? "1" : "0";

          if (node.hidden === match) {
            node.hidden = !match;
          }

          const details = menuNodeDetails.get(node);
          if (details && details.open !== descendantMatch) {
            details.open = descendantMatch;
          }
        }

        const hasVisibleTopNode = menuTopNodes.some(function (node) {
          return !node.hidden;
        });

        if (menuEmptyState) {
          menuEmptyState.hidden = hasVisibleTopNode;
        }
      } finally {
        isFilteringMenu = false;
      }
    }

    function scheduleMenuFilter(rawQuery) {
      queuedMenuFilterValue = rawQuery;
      if (filterMenuFrame) return;
      filterMenuFrame = window.requestAnimationFrame(function () {
        filterMenuFrame = 0;
        filterMenuItems(queuedMenuFilterValue);
      });
    }

    function closeMenuSheet(returnFocus) {
      if (!menuSheet || !isMenuSheetOpen()) return;
      clearSheetInlineStyles(menuSheetPanel);
      resetActiveSheetSwipe(menuSheetPanel);
      menuSheet.classList.remove("is-open");
      menuSheet.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mobile-menu-sheet-open");
      syncSheetScrollLock();
      scheduleViewportInsetsSync();

      window.clearTimeout(hideMenuSheetTimer);
      hideMenuSheetTimer = window.setTimeout(function () {
        menuSheet.hidden = true;
        syncSheetScrollLock();
      }, 210);

      resetMenuFilter();
      syncOverlayVisibilityClasses();

      if (
        returnFocus &&
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function" &&
        document.body.contains(lastFocusedElement)
      ) {
        lastFocusedElement.focus();
      }
    }

    function openMenuSheet(trigger) {
      if (!menuSheet || isMenuSheetOpen()) return;
      closeBrandSheet(false);
      closeSortSheet(false);
      closeQuickTray(false);
      closeSearchSheet(false);
      closeMenuSheet(false);
      setScrollVisibility(false);
      clearSheetInlineStyles(menuSheetPanel);

      if (isDrawerOpen() && menuSummary) {
        menuSummary.click();
      }

      lastFocusedElement = trigger || document.activeElement;
      resetMenuFilter();

      window.clearTimeout(hideMenuSheetTimer);
      menuSheet.hidden = false;
      menuSheet.setAttribute("aria-hidden", "false");
      document.body.classList.add("mobile-menu-sheet-open");
      syncSheetScrollLock();
      scheduleViewportInsetsSync();

      window.requestAnimationFrame(function () {
        menuSheet.classList.add("is-open");
      });

      syncOverlayVisibilityClasses();

      if (menuFilterInput) {
        window.setTimeout(function () {
          menuFilterInput.focus();
        }, 120);
      } else if (menuSheetPanel) {
        menuSheetPanel.focus();
      }
    }

    function openMenuDrawer() {
      if (menuSummary) menuSummary.click();
    }

    function closeCollectionFilterDrawer() {
      const collectionFilterDrawerClose = getCollectionFilterDrawerClose();
      if (collectionFilterDrawerClose) {
        collectionFilterDrawerClose.click();
        return;
      }

      const drawer = getCollectionFilterDrawerElement();
      if (drawer && typeof drawer.closeFacetsDrawer === "function") {
        drawer.closeFacetsDrawer();
        return;
      }

      const collectionFilterContainer = getCollectionFilterContainer();
      if (!collectionFilterContainer) return;

      const overlay = collectionFilterContainer.querySelector("#facets-overlay");
      if (overlay) overlay.remove();
      collectionFilterContainer.classList.remove("open");
    }

    function openCollectionFilterDrawer(tabKey) {
      const requestedTab = tabKey === "sort" ? "sort" : "filters";
      const collectionFilterTrigger = getCollectionFilterTrigger();
      if (collectionFilterTrigger) {
        collectionFilterTrigger.click();
      }

      if (isCollectionFilterDrawerOpen()) {
        const openedDrawer = getCollectionFilterDrawerElement();
        if (openedDrawer && typeof openedDrawer.setMobileTab === "function") {
          window.requestAnimationFrame(function () {
            openedDrawer.setMobileTab(requestedTab);
          });
        }
        return;
      }

      const drawer = getCollectionFilterDrawerElement();
      if (drawer && typeof drawer.openFacetsDrawer === "function") {
        drawer.openFacetsDrawer();
      }
      if (drawer && typeof drawer.setMobileTab === "function") {
        window.requestAnimationFrame(function () {
          drawer.setMobileTab(requestedTab);
        });
      }
    }

    function getCurrentSortValue() {
      const desktopSortInput = document.querySelector("#SortBy");
      if (desktopSortInput && desktopSortInput.value) {
        return desktopSortInput.value;
      }
      const params = new URLSearchParams(window.location.search);
      const fromUrl = params.get("sort_by");
      if (fromUrl) return fromUrl;
      const activeOption = sortSheet
        ? sortSheet.querySelector(".mobile-sort-sheet__link--active")
        : null;
      return activeOption ? activeOption.getAttribute("data-sort-value") || "" : "";
    }

    function syncSortSheetActiveOption(sortValue) {
      if (!sortSheetOptions || !sortSheetOptions.length) return;
      sortSheetOptions.forEach(function (option) {
        const isActive = (option.getAttribute("data-sort-value") || "") === sortValue;
        option.classList.toggle("mobile-sort-sheet__link--active", isActive);
        option.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function applyCollectionSort(sortValue) {
      if (!sortValue) return;

      const desktopSortInput = document.querySelector("#SortBy");
      if (desktopSortInput) {
        if (desktopSortInput.value !== sortValue) {
          desktopSortInput.value = sortValue;
        }
        desktopSortInput.dispatchEvent(new Event("input", { bubbles: true }));
        desktopSortInput.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        const nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("sort_by", sortValue);
        window.location.assign(nextUrl.toString());
        return;
      }

      document
        .querySelectorAll('.facets__mobile_sort_option input[name="sort_by"]')
        .forEach(function (radio) {
          radio.checked = radio.value === sortValue;
        });

      syncSortSheetActiveOption(sortValue);
    }

    function closeSortSheet(returnFocus) {
      if (!sortSheet || !isSortSheetOpen()) return;
      clearSheetInlineStyles(sortSheetPanel);
      resetActiveSheetSwipe(sortSheetPanel);
      sortSheet.classList.remove("is-open");
      sortSheet.setAttribute("aria-hidden", "true");
      document.body.classList.remove("mobile-sort-sheet-open");
      syncSheetScrollLock();
      setSortTriggerExpanded(false);

      window.clearTimeout(hideSortSheetTimer);
      hideSortSheetTimer = window.setTimeout(function () {
        sortSheet.hidden = true;
        syncSheetScrollLock();
      }, 210);

      if (
        returnFocus &&
        lastFocusedElement &&
        typeof lastFocusedElement.focus === "function" &&
        document.body.contains(lastFocusedElement)
      ) {
        lastFocusedElement.focus();
      }
    }

    function openSortSheet(trigger) {
      if (!sortSheet || isSortSheetOpen()) return;
      closeBrandSheet(false);
      closeQuickTray(false);
      closeSearchSheet(false);
      closeMenuSheet(false);
      closeCollectionFilterDrawer();
      setScrollVisibility(false);
      clearSheetInlineStyles(sortSheetPanel);
      lastFocusedElement = trigger || document.activeElement;

      syncSortSheetActiveOption(getCurrentSortValue());

      window.clearTimeout(hideSortSheetTimer);
      sortSheet.hidden = false;
      sortSheet.setAttribute("aria-hidden", "false");
      document.body.classList.add("mobile-sort-sheet-open");
      syncSheetScrollLock();
      setSortTriggerExpanded(true);

      window.requestAnimationFrame(function () {
        sortSheet.classList.add("is-open");
      });

      const focusables = getFocusableElements(sortSheet);
      if (focusables[0]) {
        focusables[0].focus();
      } else if (sortSheetPanel) {
        sortSheetPanel.focus();
      }
    }

    function openSearchModal() {
      if (!searchSummary) return;

      closeBrandSheet(false);
      closeQuickTray(false);
      closeSearchSheet(false);
      closeMenuSheet(false);
      setScrollVisibility(false);

      if (isDrawerOpen() && menuSummary) {
        menuSummary.click();
      }

      if (!isSearchOpen()) {
        searchSummary.click();
      }
    }

    function syncOverlayVisibilityClasses() {
      const drawerOpen = isDrawerOpen() || isMenuSheetOpen();
      const searchOpen = isSearchOpen() || isSearchSheetOpen();

      document.body.classList.toggle("mobile-bottom-nav-hidden-drawer", drawerOpen);
      document.body.classList.toggle("mobile-bottom-nav-hidden-search", searchOpen);

      if (drawerOpen || searchOpen) {
        closeBrandSheet(false);
        closeSortSheet(false);
        closeQuickTray(false);
        const searchSheetOpen = isSearchSheetOpen();
        if (drawerOpen && searchSheetOpen) {
          closeSearchSheet(false);
        }
        if (searchSheetOpen && isMenuSheetOpen()) {
          closeMenuSheet(false);
        }
        setScrollVisibility(false);
      }
      syncSheetScrollLock();
      syncMobileFilterBadgeFromUrl();
    }

    function shouldLockNavVisible() {
      return (
        isBrandSheetOpen() ||
        isSortSheetOpen() ||
        isQuickTrayOpen() ||
        isSearchSheetOpen() ||
        isMenuSheetOpen() ||
        isCollectionFilterDrawerOpen() ||
        isDrawerOpen() ||
        isSearchOpen() ||
        isSidecartVisible()
      );
    }

    function updateScrollVisibility() {
      const currentY = Math.max(window.scrollY || 0, 0);
      const delta = currentY - lastScrollY;

      if (shouldLockNavVisible()) {
        clearPendingScrollReveal();
        setScrollVisibility(false);
        resetScrollAccumulation();
        lastScrollY = currentY;
        scrollTicking = false;
        return;
      }

      if (delta > 0.5) {
        downDistance += delta;
        upDistance = 0;
      } else if (delta < -0.5) {
        upDistance += Math.abs(delta);
        downDistance = 0;
      }

      if (currentY <= 88) {
        clearPendingScrollReveal();
        setScrollVisibility(false);
        resetScrollAccumulation();
      } else {
        if (!isScrollHidden && downDistance > 34 && currentY > 180) {
          clearPendingScrollReveal();
          setScrollVisibility(true);
          resetScrollAccumulation();
        }

        if (isScrollHidden && upDistance > 24) {
          scheduleScrollRevealAfterViewportSettles();
          resetScrollAccumulation();
        }
      }

      lastScrollY = currentY;
      scrollTicking = false;
    }

    function handleScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(updateScrollVisibility);
    }

    if (menuButton) {
      menuButton.addEventListener("click", function () {
        closeCollectionFilterDrawer();
        if (menuSheet) {
          if (isMenuSheetOpen()) {
            closeMenuSheet(true);
            return;
          }
          openMenuSheet(menuButton);
          return;
        }

        closeBrandSheet(false);
        closeSortSheet(false);
        closeQuickTray(false);
        closeSearchSheet(false);
        openMenuDrawer();
      });
    }

    if (cartButton) {
      cartButton.addEventListener("click", function () {
        closeCollectionFilterDrawer();
        closeBrandSheet(false);
        closeSortSheet(false);
        closeQuickTray(false);
        closeSearchSheet(false);
        closeMenuSheet(false);
        setScrollVisibility(false);

        const headerCartTrigger = document.querySelector(
          ".header__icon--cart.cart--drawer-btn"
        );
        if (headerCartTrigger) {
          headerCartTrigger.dispatchEvent(
            new MouseEvent("click", { bubbles: true, cancelable: true })
          );
          return;
        }

        const cartUrl = cartButton.getAttribute("data-cart-url");
        if (cartUrl) {
          window.location.href = cartUrl;
        }
      });
    }

    if (filterButton) {
      filterButton.addEventListener("click", function () {
        closeBrandSheet(false);
        closeSortSheet(false);
        closeQuickTray(false);
        closeSearchSheet(false);
        closeMenuSheet(false);
        setScrollVisibility(false);

        if (isCollectionFilterDrawerOpen()) {
          closeCollectionFilterDrawer();
          return;
        }

        openCollectionFilterDrawer("filters");
      });
    }

    if (sortButton) {
      sortButton.addEventListener("click", function () {
        closeCollectionFilterDrawer();
        closeBrandSheet(false);
        closeQuickTray(false);
        closeSearchSheet(false);
        closeMenuSheet(false);
        setScrollVisibility(false);

        if (isSortSheetOpen()) {
          closeSortSheet(true);
          return;
        }

        openSortSheet(sortButton);
      });
    }

    if (searchButton) {
      searchButton.addEventListener("click", function () {
        closeCollectionFilterDrawer();
        closeSortSheet(false);
        if (isSearchSheetOpen()) {
          closeSearchSheet(true);
          return;
        }

        if (searchSheet) {
          openSearchSheet(searchButton);
          return;
        }

        openSearchModal();
      });
    }

    if (quickButton) {
      quickButton.addEventListener("click", function () {
        closeCollectionFilterDrawer();
        closeSortSheet(false);
        if (isQuickTrayOpen()) {
          closeQuickTray(true);
          return;
        }
        closeSearchSheet(false);
        openQuickTray(quickButton);
      });
    }

    brandTriggers.forEach(function (trigger) {
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        closeCollectionFilterDrawer();
        closeSortSheet(false);
        if (isBrandSheetOpen()) {
          closeBrandSheet(true);
          return;
        }
        closeSearchSheet(false);
        openBrandSheet(trigger);
      });
    });

    sortSheetCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeSortSheet(true);
      });
    });

    sortSheetOptions.forEach(function (optionButton) {
      optionButton.addEventListener("click", function () {
        const sortValue = optionButton.getAttribute("data-sort-value") || "";
        if (!sortValue) return;
        applyCollectionSort(sortValue);
        closeSortSheet(false);
      });
    });

    brandSheetCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeBrandSheet(true);
      });
    });

    brandSheetLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        const brandTheme = getBrandThemeFromLink(link);
        if (brandTheme) {
          setThemeColorForBrand(brandTheme);
        }
        closeBrandSheet(false);
      });
    });

    const swipeSheets = [
      {
        panel: menuSheetPanel,
        handle: menuSheetHeader,
        isOpen: isMenuSheetOpen,
        close: function () {
          closeMenuSheet(false);
        },
      },
      {
        panel: quickTrayPanel,
        handle: null,
        isOpen: isQuickTrayOpen,
        close: function () {
          closeQuickTray(false);
        },
      },
      {
        panel: searchSheetPanel,
        handle: searchSheetHeader,
        isOpen: isSearchSheetOpen,
        close: function () {
          closeSearchSheet(false);
        },
      },
      {
        panel: brandSheetPanel,
        handle: brandSheetHeader,
        isOpen: isBrandSheetOpen,
        close: function () {
          closeBrandSheet(false);
        },
      },
      {
        panel: sortSheetPanel,
        handle: sortSheetHeader,
        isOpen: isSortSheetOpen,
        close: function () {
          closeSortSheet(false);
        },
      },
    ];

    swipeSheets.forEach(function (sheet) {
      if (!sheet.panel) return;
      sheet.panel.addEventListener(
        "touchstart",
        function (event) {
          beginSheetSwipe(sheet, event);
        },
        { passive: true }
      );
      sheet.panel.addEventListener("touchmove", handleSheetSwipeMove, {
        passive: false,
      });
      sheet.panel.addEventListener("touchend", handleSheetSwipeEnd, {
        passive: true,
      });
      sheet.panel.addEventListener("touchcancel", handleSheetSwipeEnd, {
        passive: true,
      });
    });

    desktopBrandLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        const brandTheme = getBrandThemeFromLink(link);
        if (brandTheme) {
          setThemeColorForBrand(brandTheme);
        }
      });
    });

    quickTrayCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeQuickTray(true);
      });
    });

    quickTrayLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        closeQuickTray(false);
      });
    });

    searchSheetCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeSearchSheet(true);
      });
    });

    searchSheetShortcutLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        closeSearchSheet(false);
      });
    });

    menuSheetCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeMenuSheet(true);
      });
    });

    menuSheetLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        closeMenuSheet(false);
      });
    });

    menuFilterNodes.forEach(function (node) {
      menuNodeChildren.set(node, []);
      const details = node.querySelector(":scope > details.mobile-menu-sheet__details");
      if (details) {
        menuNodeDetails.set(node, details);
      }
    });

    menuFilterNodes.forEach(function (node) {
      const parentNode = node.parentElement
        ? node.parentElement.closest("[data-mobile-menu-node]")
        : null;
      if (parentNode && menuNodeChildren.has(parentNode)) {
        menuNodeChildren.get(parentNode).push(node);
      }
    });

    if (menuFilterInput) {
      menuFilterInput.addEventListener("input", function (event) {
        scheduleMenuFilter(event.target.value);
      });
    }

    menuAccordionDetails.forEach(function (details) {
      details.addEventListener("toggle", function () {
        if (isFilteringMenu) return;
        if (!details.open) return;

        const parentList = details.closest("ul");
        if (!parentList) return;

        parentList
          .querySelectorAll(":scope > li > details.mobile-menu-sheet__details[open]")
          .forEach(function (openDetails) {
            if (openDetails !== details) {
              openDetails.open = false;
            }
          });
      });
    });

    document.addEventListener("keydown", function (event) {
      const brandOpen = isBrandSheetOpen();
      const sortOpen = isSortSheetOpen();
      const quickOpen = isQuickTrayOpen();
      const searchSheetOpen = isSearchSheetOpen();
      const menuSheetOpen = isMenuSheetOpen();
      if (!brandOpen && !sortOpen && !quickOpen && !searchSheetOpen && !menuSheetOpen) return;

      if (event.key === "Escape") {
        if (brandOpen) closeBrandSheet(true);
        if (sortOpen) closeSortSheet(true);
        if (quickOpen) closeQuickTray(true);
        if (searchSheetOpen) closeSearchSheet(true);
        if (menuSheetOpen) closeMenuSheet(true);
        return;
      }

      if (event.key !== "Tab") return;

      let activeContainer = quickTray;
      let activePanel = quickTrayPanel;
      if (brandOpen) {
        activeContainer = brandSheet;
        activePanel = brandSheetPanel;
      } else if (sortOpen) {
        activeContainer = sortSheet;
        activePanel = sortSheetPanel;
      } else if (searchSheetOpen) {
        activeContainer = searchSheet;
        activePanel = searchSheetPanel;
      } else if (menuSheetOpen) {
        activeContainer = menuSheet;
        activePanel = menuSheetPanel;
      }
      const focusables = getFocusableElements(activeContainer);

      if (!focusables.length) {
        if (activePanel) activePanel.focus();
        event.preventDefault();
        return;
      }

      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      const activeElement = document.activeElement;

      if (event.shiftKey && (activeElement === first || activeElement === activePanel)) {
        last.focus();
        event.preventDefault();
      } else if (!event.shiftKey && activeElement === last) {
        first.focus();
        event.preventDefault();
      }
    });

    if (menuDrawerDetails) {
      menuDrawerDetails.addEventListener("toggle", syncOverlayVisibilityClasses);
    }

    if (searchModalDetails) {
      const searchObserver = new MutationObserver(syncOverlayVisibilityClasses);
      searchObserver.observe(searchModalDetails, {
        attributes: true,
        attributeFilter: ["open"],
      });
    }

    if (sidecart) {
      const sidecartObserver = new MutationObserver(function () {
        if (isSidecartVisible()) {
          setScrollVisibility(false);
          resetScrollAccumulation();
        } else {
          updateScrollVisibility();
        }
      });

      sidecartObserver.observe(sidecart, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("orientationchange", function () {
      setScrollVisibility(false);
      resetScrollAccumulation();
      lastScrollY = Math.max(window.scrollY || 0, 0);
      scheduleViewportInsetsSync();
      syncSheetScrollLock();
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth >= 750) {
        closeBrandSheet(false);
        closeSortSheet(false);
        closeQuickTray(false);
        closeSearchSheet(false);
        closeMenuSheet(false);
      }
      scheduleViewportInsetsSync();
      syncSheetScrollLock(window.innerWidth >= 750);
    });

    if (window.visualViewport) {
      window.visualViewport.addEventListener("resize", scheduleViewportInsetsSync);
      window.visualViewport.addEventListener("scroll", scheduleViewportInsetsSync);
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        closeBrandSheet(false);
        closeSortSheet(false);
        closeQuickTray(false);
        closeSearchSheet(false);
        closeMenuSheet(false);
        syncSheetScrollLock(true);
      }
    });

    window.addEventListener("pagehide", function () {
      closeBrandSheet(false);
      closeSortSheet(false);
      closeQuickTray(false);
      closeSearchSheet(false);
      closeMenuSheet(false);
      syncSheetScrollLock(true);
    });

    installThemeColorHistorySync();
    window.addEventListener("popstate", syncThemeColorFromState);
    window.addEventListener("popstate", syncMobileFilterBadgeFromUrl);
    window.addEventListener("mobile-brand-theme-history-change", function () {
      window.requestAnimationFrame(syncThemeColorFromState);
      window.requestAnimationFrame(syncMobileFilterBadgeFromUrl);
    });
    window.addEventListener("facet:search-params-changed", function () {
      window.requestAnimationFrame(syncMobileFilterBadgeFromUrl);
    });

    syncOverlayVisibilityClasses();
    syncViewportInsets();
    syncThemeColorFromState();
    syncMobileFilterBadgeFromUrl();
    installCartFetchObserver();
    observeHeaderCartBubble();
    observeHeaderCartBubbleReplacements();
    scheduleCartCountRefresh(0);
    syncSheetScrollLock();
    updateScrollVisibility();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileBottomNav);
  } else {
    initMobileBottomNav();
  }
})();
